import { gql } from '@common/hooks';
import { UploadFile } from 'antd';

export const CreateExtensionOfferMutation = gql`
  mutation CreateExtensionOfferMutation(
    $staffingRequestAssignmentId: ID!
    $input: CreateExtensionOfferMutationInput!
    $approvalChainTemplateSource: String
    $deviated: Boolean
  ) {
    createExtensionOffer(
      staffingRequestAssignmentId: $staffingRequestAssignmentId
      input: $input
      approvalChainTemplateSource: $approvalChainTemplateSource
      deviated: $deviated
    ) {
      extensionOffer {
        id
        state

        approvalChains {
          id
          currentApprovers {
            id
            name
          }
        }

        notVoidedSourceAssignmentTerms {
          id
          startDate
          endDate
          billingRegularRate
          timeoffDescription
          shiftsPerWeek
          shiftType
        }

        # Refetch parent application and all offers
        staffingRequestAssignment {
          id
          extensionCount

          activeExtensionOffer {
            id
            endDate
            originalEndDate
            timeoffDescription
            shiftType
            originalShiftType
            billingRegularRate
            originalBillingRegularRate
            createdAt
            state
            stateChangedAt
            extensionReason
            rejectionReason
            rejectionNotes
            shiftsPerWeek
            hoursPerShift
            originalShiftsPerWeek
            originalHoursPerShift

            canReview {
              value
            }

            canRetract {
              value
            }

            canAccept {
              value
            }

            canReject {
              value
            }

            canApprove {
              value
            }
          }
        }
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export type CreateExtensionOfferMutationVariables = {
  staffingRequestAssignmentId: string;
  input: {
    approvalDocument: UploadFile;
    startDate: string;
    endDate: string;
    billingRegularRate: number;
    timeoffDescription: string;
    shiftsPerWeek: number;
    hoursPerShift: number;
    shiftType: string;
    extensionReason: string;
    commentContent: string;
    overtimeThreshold: number;
  };
  approvalChainTemplateSource: string;
  deviated: boolean;
};

export type CreateExtensionOfferMutationResponse = {
  createExtensionOffer: {
    extensionOffer?: {
      id: string;
      state: string;
      approvalChains: {
        id: string;
        currentApprovers: {
          id: string;
          name: string;
        }[];
      }[];
      notVoidedSourceAssignmentTerms: {
        id: string;
        startDate: string;
        endDate: string;
        billingRegularRate: number;
        timeoffDescription: string;
        shiftsPerWeek: number;
        shiftType: string;
      }[];
    };
    errors?: {
      attribute: string;
      humanAttribute: string;
      errors: string[];
      fullErrors: string[];
    }[];
  };
};
